import { Component } from '@angular/core';
import { AcknowledgementListComponent } from '../acknowledgement-list.component';

@Component({
  selector: 'app-acknowledgement-list-mobile',
  templateUrl: './acknowledgement-list-mobile.component.html',
  styleUrls: ['./acknowledgement-list-mobile.component.scss']
})
export class AcknowledgementListMobileComponent extends AcknowledgementListComponent {

}
